// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderInvoiceLine } from './purchase-order-invoice-line';
import { PurchaseOrderLine } from './purchase-order-line';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderLineReceiving extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
        return this.quantity * this.purchaseOrderLine.cost;
    }

    get readyToExportDisplay() {
        return !!this.readyToExport;
    }
    get exportedDisplay() {
        return !!this.quickBooksId;
    }

    get vendorDisplay() {
        return this.purchaseOrderLine.purchaseOrder.vendor.companyName ?? '';
    }

    get poNumberDisplay() {
        return this.purchaseOrderLine.purchaseOrder.pONumber ?? '';
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdById?: number;
  deleted?: Date;
  deletedById?: number;
  purchaseOrderLineId!: number;
  quantity!: number;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  quickBooksOnlineId?: string;
  quickBooksOnlineLastExport?: Date;
  readyToExport?: Date;
  createdBy!: User;
  deletedBy!: User;
  purchaseOrderInvoiceLines!: PurchaseOrderInvoiceLine[];
  purchaseOrderLine!: PurchaseOrderLine;
}

